<template>
    <div class="page" @touchmove.prevent>
        <div :class="['popup-con', switch3DCat ? 'pop3d-h' : 'pop-h']" v-show="benefitInfo">
            <div class="popup-close" @click="closePopup"></div>
            <div :class="switch3DCat ? 'title-icon3D' : 'title-icon'">
                <img
                    v-show="switch3DCat"
                    style="width: 83px; height: 100px"
                    src="../../../../assets/iconV2.5/icon3D_popup_upgrade@2x.png"
                />
            </div>
            <div class="pop-title">恭喜您激活成功</div>
            <div class="pop-desc">活力值领取后180天内有效</div>
            <div class="grade-area" v-if="benefitInfo && benefitInfo.length > 0">
                <div class="grade-card" v-for="(item, index) in benefitInfo" :key="index">
                    <div class="card-head">
                        {{ item.title }}
                    </div>
                    <div class="card-value">{{ item.desc }}</div>
                    <div class="card-desc">新人专享</div>
                </div>
            </div>
            <div class="tab-pop-butn" @click="confirm">
                {{ benefitInfo && benefitInfo.length === 1 ? '立即使用' : '我知道了' }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['scoreInfoData', 'switch3DCat', 'showFirstUpgrade'],
    data() {
        return {
            benefitInfo: null
        };
    },
    watch: {
        showFirstUpgrade(newV) {
            if (newV) {
                this.getnovicebenefitinfo();
            }
        }
    },
    methods: {
        async getnovicebenefitinfo() {
            const { Result, Content } = await this.$http.getnovicebenefitinfo();
            if (Result === 200) {
                if (Content.noviceBenefitList && Content.noviceBenefitList.length > 3) {
                    const list = Content.noviceBenefitList.splice(0, 3);
                    this.benefitInfo = list;
                } else if (Content.noviceBenefitList) {
                    this.benefitInfo = Content.noviceBenefitList || [];
                } else {
                    this.benefitInfo = [];
                }
            } else {
                this.benefitInfo = [];
            }
            if (this.benefitInfo) {
                this.benefitInfo.forEach(element => {
                    this.POINT('h5_element_imp', {
                        page: 'super-成长权益页',
                        tgt_event_id: 'h5_ACT_privilege_box',
                        tgt_name: 'h5-ACT-成长权益-弹窗',
                        param: this.scoreInfoData ? this.scoreInfoData.score : '',
                        param1: '激活弹窗',
                        param2: this.scoreInfoData ? this.scoreInfoData.allScore : '',
                        param3: this.switch3DCat ? '是' : '否',
                        param4: '新人权益',
                        param5: element.title,
                        param6: element.desc,
                        param7: element.couponBatchNo
                    });
                });
            } else {
                this.POINT('h5_element_imp', {
                    page: 'super-成长权益页',
                    tgt_event_id: 'h5_ACT_privilege_box',
                    tgt_name: 'h5-ACT-成长权益-弹窗',
                    param: this.scoreInfoData ? this.scoreInfoData.score : '',
                    param1: '激活弹窗',
                    param2: this.scoreInfoData ? this.scoreInfoData.allScore : '',
                    param3: this.switch3DCat ? '是' : '否',
                    param4: '统一展示类'
                });
            }
        },
        closePopup() {
            this.$emit('OnConfirmClick');
        },
        confirm() {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_event_id: 'h5_ACT_privilege_box',
                tgt_name: 'h5-ACT-成长权益-弹窗',
                param: this.scoreInfoData.score,
                param1: '激活弹窗',
                param2: '去领权益',
                param3: this.switch3DCat ? '是' : '否'
            });
            if (this.benefitInfo && this.benefitInfo.length === 1) {
                this.receivenovicebenefit(this.benefitInfo[0]);
            } else {
                this.$emit('OnConfirmClick');
            }
        },
        async receivenovicebenefit(item) {
            const { Result, Content, ResultMessage } = await this.$http.receivenovicebenefit({
                awardKey: item.awardKey
            });
            if (Result === 200) {
                this.$toast({ message: '领取成功', duration: 2000 });
                if (Content.redirectUrl) {
                    setTimeout(() => {
                        this.$emit('OnConfirmClick');
                        this.openLink(Content.redirectUrl);
                    }, 2000);
                }
            } else {
                this.$toast({ message: ResultMessage, duration: 2000 });
            }
        }
    }
};
</script>
<style lang="less" scoped>
@asserts: '../../../../assets/iconV2.5/';
.page {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 100;
    .pop3d-h {
        // height: 198px;
    }
    .pop-h {
        // height: 247px;
    }
    .popup-con {
        width: 303px;
        border-radius: 10px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        .popup-close {
            width: 20px;
            height: 20px;
            margin-left: 246px;
            margin-top: 16px;
            background-size: 100% 100%;
            background-image: url('@{asserts}/tasklist-pop-close@2x.png');
        }
        .title-icon {
            width: 74px;
            height: 52px;
            margin-top: -10px;
            background-size: 100% 100%;
            background-image: url('@{asserts}/icon_popup_upgrade@2x.png');
        }
        .title-icon3D {
            margin-top: -100px;
            margin-bottom: 10px;
            // background-size: 100% 100%;
            // background-image: url('@{asserts}/icon3D_popup_upgrade@2x.png');
        }
        .pop-title {
            margin-top: 20px;
            color: #384369;
            font-size: 18px;
            // font-family: fzlt_bold;
            font-weight: bold;
        }
        .pop-desc {
            margin-top: 11px;
            color: #49596c;
            font-size: 15px;
            // font-family: fzlt;
            text-align: center;
        }
        .grade-area {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin: 24px 8px 0;
            width: 287px;
            height: 116px;
            background: #f9f7f7;
            border-radius: 6px;
            .grade-card {
                width: 84px;
                height: 81px;
                background-color: #fff;
                border-radius: 8px;
                box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.06);
                border: 1px solid #e7dcd8;
                text-align: center;
                margin: 0 4px;
                .card-head {
                    width: 100%;
                    height: 24px;
                    border-radius: 7px 7px 0px 0px;
                    color: #fff;
                    font-size: 12px;
                    // font-family: fzlt;
                    line-height: 24px;
                    background: linear-gradient(180deg, #ffb03a 0%, #f8a427 100%);
                }
                .card-value {
                    margin-top: 13px;
                    color: #ff4d00;
                    font-size: 13px;
                    // font-family: fzlt_bold;
                    font-weight: bold;
                }
                .card-desc {
                    margin-top: 6px;
                    color: #3f5862;
                    font-size: 10px;
                    // font-family: fzlt;
                }
            }
        }
        .tab-pop-butn {
            margin-top: 24px;
            margin-bottom: 22px;
            width: 223px;
            height: 44px;
            background: linear-gradient(270deg, #3ca5e2 0%, #4dbaf9 100%);
            border-radius: 8px;
            text-align: center;
            line-height: 44px;
            color: #fff;
            font-size: 18px;
            // font-family: fzlt_bold;
            font-weight: bold;
        }
    }
}
</style>
